import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Link, Redirect} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Actions} from "../../core";
import {InviterPopup} from "../InviterPopup/InviterPopup";
import _ from 'lodash'
import Moment from "moment";
import moment from "moment";

export const  UserPage = ({page}) =>{
  const [loader,setLoader] = useState(false)
  const user  = useSelector(store=>store.Store.User);
  const dispatch = useDispatch();
  const [errors,setErrors] = useState({});
  const [userData, setUserData] = useState({
    "username":"",
    "email":"",
    "password":"",
    "confirm_password":"",
    "city":"",
    "real_address":"BASSIANI",
    "fullname":"",
    "id_number":"",
    "date_of_birth":"",
    "phone":"",
    "facebook_url":"",
    "agreement":"agree"
  })
  const [invites,setInvites] = useState([]);
  const renderUserInfo=(page)=> {
    return (page ==='info')
      ?(<div id="user-info-options">

      <div className="user-info">
        <p>Username:<span> {user.data.username} </span></p>
        <p>E-Mail:<span> {user.data.email} </span></p>
        <p>Full Name:<span> {user.data.fullname} </span></p>
        <p>ID Number:<span> {user.data.id_number} </span></p>
        <p>Phone:<span> {user.data.phone} </span></p>
        <p>Network:<a href={user.data.facebook_url} target={"_blank"}> {user.data.facebook_url} </a></p>
        <br/><br/>

        <span onClick={()=> dispatch(Actions.User.Logout()) } style={{cursor:'pointer'}}>LOGOUT</span>
      </div>
    </div>):null
  }
  const  renderRegister=(page)=> {

    const captcha=()=>{
      if(loader)return;

      window.grecaptcha.execute('6Lc48aEdAAAAAPIKRiPrfZK-zFzlGxbx54HXgI21', {action: 'submit'}).then(async(token)=> {
        // Add your logic to submit to your backend server here.
        if(token){
          setLoader(true)
          const response = await dispatch(Actions.User.Register(token,userData));
          setLoader(false)
          if(!response["status"]){
            setErrors(response["data"]["errors"])
          }else{
            setUserData({
              "username":"",
              "email":"",
              "password":"",
              "confirm_password":"",
              "city":"",
              "real_address":"BASSIANI",
              "fullname":"",
              "id_number":"",
              "date_of_birth":"",
              "phone":"",
              "facebook_url":"",
              "agreement":"agree"
            })
            dispatch({type:'POPUP_WINDOW',payload:true,modal: "login"})
          }

        }else{
           console.log(token)
        }
      });
    }
    if(page==="register"){
        return (
          <div id="edit-prof">
            {
              (user.isLogged)? <Redirect to={"/user/info"} />: null
            }
            <table>
              <tbody>
              <tr>
                <td><label htmlFor="username2"  className={`${errors['username']?'error-border':''}`}>username</label></td>
                <td><input id="username2" placeholder="XXXXXXXXXXXXXXXXX" type="text" value={userData.username} onChange={e=>setUserData({...userData,username:e.target.value})}/></td>
              </tr>
              <tr  >
                <td ><label htmlFor="email2" className={`${errors['email']?'error-border':''}`}>email</label></td>
                <td><input id="email2" placeholder="XXXXXXXXXXXXXXXXX" type="email"  name="email" value={userData.email} onChange={e=>setUserData({...userData,email:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="password2" className={`${errors['password']?'error-border':''}`}>password</label></td>
                <td><input id="password2" placeholder="XXXXXXXXXXXXXXXXX" type="password" value={userData.password}  onChange={e=>setUserData({...userData,password:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="password21" className={`${errors['confirm_password']?'error-border':''}`}>confirm password</label></td>
                <td><input id="password21" placeholder="XXXXXXXXXXXXXXXXX" type="password" value={userData.confirm_password}  onChange={e=>setUserData({...userData,confirm_password:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="city2" className={`${errors['city']?'error-border':''}`}>Country</label></td>
                <td><input id="city2" placeholder="XXXXXXXXXXXXXXXXX" type="text" value={userData.city}  onChange={e=>setUserData({...userData,city:e.target.value})}/></td>
              </tr>
             {/* <tr >
                <td><label htmlFor="address2" className={`${errors['real_address']?'error-border':''}`}>real address</label></td>
                <td><input id="address2" placeholder="XXXXXXXXXXXXXXXXX" type="text" value={userData.real_address}  onChange={e=>setUserData({...userData,real_address:e.target.value})}/></td>
              </tr>*/}
              <tr >
                <td><label htmlFor="fullname2" className={`${errors['fullname']?'error-border':''}`}>full name</label></td>
                <td><input id="fullname2" placeholder="XXXXXXXXXXXXXXXXX" type="text" value={userData.fullname}  onChange={e=>setUserData({...userData,fullname:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="idnumber2" className={`${errors['id_number']?'error-border':''}`}>id number</label></td>
                <td><input id="idnumber2" placeholder="XXXXXXXXXXXXXXXXX" type="text" value={userData.id_number}  onChange={e=>setUserData({...userData,id_number:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="date2" className={`${errors['date_of_birth']?'error-border':''}`}>date of birth</label></td>
                <td><input id="date2" placeholder="XXXXXXXXXXXXXXXXX" type="date" format={"dd/mm/yyyy"}  value={userData.date_of_birth}  onChange={e=>setUserData({...userData,date_of_birth:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="phone2" className={`${errors['phone']?'error-border':''}`}>phone</label></td>
                <td><input id="phone2" placeholder="XXXXXXXXXXXXXXXXX" type="number" value={userData.phone}  onChange={e=>setUserData({...userData,phone:e.target.value})}/></td>
              </tr>
              <tr >
                <td><label htmlFor="facebook2" className={`${errors['facebook_url']?'error-border':''}`}>facebook/instagram</label></td>
                <td><input id="facebook2" placeholder="XXXXXXXXXXXXXXXXX" type="url" value={userData.facebook_url}  onChange={e=>setUserData({...userData,facebook_url:e.target.value})}/></td>
              </tr>
              </tbody>
            </table>
            <p id="agree-change"  className={`${userData.agreement === 'agree'? 'active':''} `} onClick={()=>setUserData({...userData, agreement:  (userData.agreement !== 'agree')? 'agree':""})}>
              I agree to the
            </p>
            <p onClick={()=>window.location.href="/dark/contact/terms"} className={`terms-conditions ${errors['agreement']?'error-border':''}`} style={{cursor:"pointer", textDecoration:"underline"}}>
              terms and conditions
            </p>
            <span style={{color:'red'}}>{errors['general']}</span>
            <br/>
            {
              loader?<span className={"submit-btn"} style={{cursor:"pointer", fontSize:20}} >{loader?"PLEASE WAIT...":"REGISTER"}</span>:<span className={"submit-btn"} style={{cursor:"pointer", fontSize:20}} onClick={()=>captcha()}>{loader?"PLEASE WAIT...":"REGISTER"}</span>
            }


          </div>

        )
      }
      return null;
  }
  const renderTransactions=(page)=> {
     if(page === 'transactions'){
        return (
          <div id="user-inviter">
            {
              redirect()
            }
            <table>
              <thead>
              <tr>
                <td>#</td>
                <td>type</td>
                <td>night</td>
                <td>night date</td>
                <td>ticket price</td>
                <td>purchase date</td>
                <td>print ticket</td>
              </tr>
              </thead>
              <tbody>
              {
                _.map(user.tickets,(ticket,index)=>{
                      return (
                        <tr key={index}>
                          <td>{ticket?.id}</td>
                          <td>{ticket?.type ==='event'? 'Ticket':'Invitation'}</td>
                          <td>{ticket?.title}</td>
                          <td>{moment(ticket?.event_start).format("DD MMM, YYYY HH:mm:ss")}</td>
                          <td>{ticket?.price || 0} GEL</td>
                          <td>{moment(ticket?.payment_date).format("DD MMM, YYYY HH:mm:ss")}</td>
                          <td> {
                            ticket?.t_type === 'new' && <a href={`https://tickets.bassiani.com${ticket.type==='event'? '/member/ticket/'+ticket.uuid:'/guest/invitation/'+ticket.uuid }`} target={"_blank"}><span className="ticket-ico"/></a>
                          }
                          </td>
                        </tr>
                      )
                })
              }
              </tbody>
            </table>
          </div>
        )
     }
     return false;
  }
  function sendInvite(item) {
    Actions.Inviter.sendPaidInvite( {
      id:item.id,
      email:item.email,
      uuid:item.uuid,
      from:item.from,
      event:item.event,
      timestamp: Moment(item.event_start).format("DD MMM / YYYY hh:mm").toString()
  }).then((response)=>{
        if(response?.data?.data?.status==="OK"){
            alert("ticket sent")
        }else{
          alert("error")
        }
    })

  }
  function sendOrder(item) {

    Actions.Inviter.sendOrder( {
      id:item.id,
  }).then((response)=>{

    console.log(response)
      if(response?.data?.status==="OK"){
        alert("order sent")
      }else{
        alert("error")
      }
    })

  }

  const deleteInvitation=(v)=>{
      if(window.confirm("Are you sure you want to delete?")){
        Actions.Inviter.deleteOrder( {
          id:v.trans_id,
        }).then((response)=>{

          if(response.status){
            getInvites().then(setInvites);
          }else{
            alert("error")
          }
        })
      }
  }

  const renderInvites=(page)=> {
     if(page === 'invites'){
        return (
          <div id="user-inviter">
            <InviterPopup user={user} onUpdateInvite={()=>{
              getInvites().then(setInvites);
            }}/>

            <br/>
            <span style={{cursor:'pointer'}} onClick={()=>{
              dispatch({type:'POPUP_WINDOW',payload:true,modal: "inviter"})
            }}>SEND AN INVITATION</span>
            {
              redirect()
            }
            <table>
              <thead>
              <tr>
                <td  >#</td>
                <td>night</td>
                <td>night date</td>
                <td>username/email</td>
                <td>id number</td>
                <td >qty</td>
                <td>price</td>
                <td >free</td>
                <td>status</td>
                <td>print</td>
              </tr>
              </thead>
              <tbody>
              {
                _.map(invites,  (v,k)=>{
                  return (
                    <tr key={k}>
                      <td>{v.id}</td>
                      <td>{v.title}</td>
                      <td>{Moment(v["event_start"]).format("DD MMM / YYYY hh:mm").toString()}</td>
                      <td><p>{v.name}</p> <span style={{fontSize:'0.8rem'}}>{v.email}</span></td>
                      <td>{v.pin}</td>
                      <td>{v.quantity}</td>
                      <td>{v.price}</td>
                      <td>{v.free}</td>
                      <td>{v.trans_status === 1?v.status:(v.trans_status===2?'used':<span style={{color:"red"}}>deleted</span>)}</td>
                      <td>
                        {
                          v.trans_status !==3 &&  <div style={{display:'flex',flexDirection:"row", justifyContent:'space-between',alignItems:'center'}}>&nbsp;
                            <a href={`https://tickets.bassiani.com/guest/invitation/${v.uuid}`} target={"_blank"}><span className="ticket-ico"/></a> &nbsp;
                            {v.free==="no" && v.status==="unpaid" && <a href={`https://bassiani.com/light/nights/${v.event_id}?uuid=${v.uuid}`} target={"_blank"}><span className="pay-icon"/></a>}&nbsp;
                            {v.free==="no" && v.status==="unpaid" && <span className="send-icon" onClick={()=>sendOrder(v)}/>}&nbsp;
                            {v.free==="no" && v.status==="paid" && <span className="send-icon" onClick={()=>sendInvite(v)}/>}&nbsp;
                            {((v.free==="no" && v.status==="unpaid") || (v.free==="yes")) && v.trans_status!==2 &&   <span className="delete-icon" onClick={()=>deleteInvitation(v)}/>}&nbsp;
                          </div>
                        }


                      </td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
        )
     }
     return false;
  }
  const redirect=()=>{

     return (user.isLogged)? null: <Redirect to={"/"} />

  }
  function renderStatus({verified,blocked}) {
      if(blocked===1){
        return 'Unverified';
      }
      switch (verified){
        case 1: return 'Verified';
        case 0: return 'Unverified';
        default: return 'Pending';
      }
  }
  const renderUserStatus=(page)=> {
    if(page === 'register'){
       return null;
    }
    return   (<div id="user-status">
            <div className={`user-status-info ${user.data.verified===1 && user.data.blocked !==1? 'verified':''}`}>user status :<span> {renderStatus(user.data)}</span></div>
            <div className="user-page-tags">
              <span><Link to={"/user/info"}> user</Link>//</span>
              <span> <Link to={"/user/transactions"}> order history</Link>// </span>
              {
                user.isLogged && user?.data?.enableInviter  && <span><Link to={"/user/invites"}> inviter </Link></span>
              }
            </div>
          </div>)
  }
  useEffect(()=>{
    getInvites().then(setInvites);
    dispatch(Actions.User.GetMyTickets())
  },[])
  const getInvites = async ()=>await dispatch(Actions.Inviter.getInvites());
  return (
    <section className="user-page">
      {
        (!user.isLogged && page  !== 'register')? <Redirect to={"/"} />:null
      }
      {
        user.isLogged?renderUserStatus():null
      }
      {
        user.isLogged?renderUserInfo(page):null
      }
      {
        renderRegister(page)
      }
      {
        user.isLogged?renderTransactions(page):null
      }
      {
        user.isLogged && user?.data?.enableInviter  && renderInvites(page)
      }
    </section>
  )
}
UserPage.propTypes = {
  page: PropTypes.string
}
